export enum DuplicableElementsInputIdEnum {
    "GR-Organisations-Subsection",
    "GR-Organisations-Section",
    "GR-TenderingParty-Section",
    "GR-SettledContract-Section",
    "GR-LotTender-Section",
    "GR-LotResult-Section"
}
